/**
 * SeriesScopeDialog — Sep 2026 (replaces the stacked window.confirm
 * prompts when editing an appointment that belongs to a recurring
 * series). Offers the three scopes explicitly; closing/cancel aborts
 * the save so nothing changes by accident.
 */
import React from 'react';
import { Repeat } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';

export const SeriesScopeDialog = ({ open, onChoose }) => (
  <Dialog open={open} onOpenChange={(o) => { if (!o) onChoose(null); }}>
    <DialogContent className="max-w-md" data-testid="series-scope-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Repeat className="h-5 w-5 text-teal-600" aria-hidden="true" />
          Apply changes to the recurring series?
        </DialogTitle>
        <DialogDescription>
          This appointment is part of a recurring series. Choose how far your changes should apply. Time changes shift each appointment by the same amount.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-2">
        <Button className="w-full justify-start" variant="outline" onClick={() => onChoose('this_only')} data-testid="series-scope-this-only">
          Only this appointment
        </Button>
        <Button className="w-full justify-start" variant="outline" onClick={() => onChoose('all_future')} data-testid="series-scope-all-future">
          This and all future appointments
        </Button>
        <Button className="w-full justify-start" variant="outline" onClick={() => onChoose('entire_series')} data-testid="series-scope-entire-series">
          The entire series (past + future)
        </Button>
      </div>
      <DialogFooter>
        <Button variant="ghost" onClick={() => onChoose(null)} data-testid="series-scope-cancel">Cancel — don't save</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default SeriesScopeDialog;
